// src/components/AttendanceCatechismTab.js
import React from 'react';

const AttendanceCatechismTab = ({
  students,
  catechismAttendanceDates,
  selectedCatechismDate,
  handleCatechismDateChange,
  displayedCatechismDates,
  handleStudentClick,
  getAttendanceClass,
  handleEditAttendance,
  formatDisplayDate,
  dateLocks = {}, // 🌟 Nhận danh sách ngày khóa
}) => {
  return (
    <>
      <h4>Điểm danh Học Giáo Lý</h4>
      <table className="student-table">
        <thead>
          <tr>
            <th>Stt</th>
            <th>ID</th>
            <th>Tên Thánh</th>
            <th className="sticky-name-col">Họ và Tên</th>
            <th className="mobile-only">
              <select value={selectedCatechismDate} onChange={handleCatechismDateChange}>
                {catechismAttendanceDates.slice().reverse().map((date, index) => (
                  <option key={index} value={date}>
                    {formatDisplayDate(date)} {dateLocks[date] ? '🔒 (Đã khóa)' : ''}
                  </option>
                ))}
              </select>
            </th>
            {displayedCatechismDates.map((date, index) => (
              <th key={index} className="desktop-only">
                {formatDisplayDate(date)}
                {dateLocks[date] && (
                  <span title="Ngày đã bị khóa điểm danh bổ sung" style={{ marginLeft: 4, cursor: 'help' }}>
                    🔒
                  </span>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {students.map((student, index) => (
            <tr key={student.id || index}>
              <td>{index + 1}</td>
              <td style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{student.id}</td>
              <td>{student.holyName || '-'}</td>
              <td className="sticky-name-col">
                <button
                  className="student-name-link"
                  onClick={() => handleStudentClick(student.id)}
                >
                  {student.fullName}
                </button>
              </td>
              <td className="mobile-only">
                <button
                  className={getAttendanceClass(student.catechismAttendance?.[selectedCatechismDate]?.time).className}
                  disabled={getAttendanceClass(student.catechismAttendance?.[selectedCatechismDate]?.time).isDisabled}
                  onClick={() =>
                    !getAttendanceClass(student.catechismAttendance?.[selectedCatechismDate]?.time).isDisabled &&
                    handleEditAttendance(student, selectedCatechismDate, 'catechism')
                  }
                >
                  {student.catechismAttendance?.[selectedCatechismDate]?.time || 'Vắng không xin phép'}
                </button>
              </td>
              {displayedCatechismDates.map((date, idx) => (
                <td key={idx} className="desktop-only">
                  <button
                    className={getAttendanceClass(student.catechismAttendance?.[date]?.time).className}
                    disabled={getAttendanceClass(student.catechismAttendance?.[date]?.time).isDisabled}
                    onClick={() =>
                      !getAttendanceClass(student.catechismAttendance?.[date]?.time).isDisabled &&
                      handleEditAttendance(student, date, 'catechism')
                    }
                  >
                    {student.catechismAttendance?.[date]?.time || 'Vắng không xin phép'}
                  </button>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default AttendanceCatechismTab;